(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("tagsEventsDataService", tagsEventsDataService);

    tagsEventsDataService.$inject = [];

    function tagsEventsDataService() {
        var self = this;
        var _emitter = JarEventEmitter.call(self);

        self.EVENTS = {
            ON_TAGS_ASSIGNED_BEFORE: "ON_TAGS_ASSIGNED_BEFORE",
            ON_TAGS_ASSIGNED_AFTER: "ON_TAGS_ASSIGNED_AFTER",
            ON_TAGS_ASSIGNED_ERROR: "ON_TAGS_ASSIGNED_ERROR",
            ON_TAGS_UNASSIGNED_BEFORE: "ON_TAGS_UNASSIGNED_BEFORE",
            ON_TAGS_UNASSIGNED_AFTER: "ON_TAGS_UNASSIGNED_AFTER",
            ON_TAGS_UNASSIGNED_ERROR: "ON_TAGS_UNASSIGNED_ERROR",
            ON_TAG_CREATED_BEFORE: "ON_TAG_CREATED_BEFORE",
            ON_TAG_CREATED_AFTER: "ON_TAG_CREATED_AFTER",
            ON_TAG_CREATED_ERROR: "ON_TAG_CREATED_ERROR",
            ON_TAG_UPDATED_BEFORE: "ON_TAG_UPDATED_BEFORE",
            ON_TAG_UPDATED_AFTER: "ON_TAG_UPDATED_AFTER",
            ON_TAG_UPDATED_ERROR: "ON_TAG_UPDATED_ERROR",
            ON_TAGS_ORDER_UPDATED: "ON_TAGS_ORDER_UPDATED",
            ON_TAG_DELETED_BEFORE: "ON_TAG_DELETED_BEFORE",
            ON_TAG_DELETED_AFTER: "ON_TAG_DELETED_AFTER",
            ON_TAG_DELETED_ERROR: "ON_TAG_DELETED_ERROR",
            ON_TAGS_FILTER_UPDATED: "ON_TAGS_FILTER_UPDATED",
        };

        self.emit = function (eventName) {
            //eventName argument for readability purposes
            _emitter.trigger.apply(self, arguments);
        };

        self.onBeforeAssign = function (callBack) {
            return self.on(self.EVENTS.ON_TAGS_ASSIGNED_BEFORE, callBack);
        };

        self.onAfterAssign = function (callBack) {
            return self.on(self.EVENTS.ON_TAGS_ASSIGNED_AFTER, callBack);
        };

        self.onAssignFailed = function (callBack) {
            return self.on(self.EVENTS.ON_TAGS_UNASSIGNED_ERROR, callBack);
        };

        self.onBeforeUnassign = function (callBack) {
            return self.on(self.EVENTS.ON_TAGS_UNASSIGNED_BEFORE, callBack);
        };

        self.onAfterUnassign = function (callBack) {
            return self.on(self.EVENTS.ON_TAGS_UNASSIGNED_AFTER, callBack);
        };

        self.onUnassignFailed = function (callBack) {
            return self.on(self.EVENTS.ON_TAGS_UNASSIGNED_ERROR, callBack);
        };

        self.onBeforeCreate = function (callBack) {
            return self.on(self.EVENTS.ON_TAG_CREATED_BEFORE, callBack);
        };

        self.onAfterCreate = function (callBack) {
            return self.on(self.EVENTS.ON_TAG_CREATED_AFTER, callBack);
        };

        self.onTagsOrdered = (callBack) => {
            return self.on(self.EVENTS.ON_TAGS_ORDER_UPDATED, callBack);
        };

        self.onCreateFailed = function (callBack) {
            return self.on(self.EVENTS.ON_TAG_CREATED_ERROR, callBack);
        };

        self.onBeforeUpdate = function (callBack) {
            return self.on(self.EVENTS.ON_TAG_UPDATED_BEFORE, callBack);
        };

        self.onAfterUpdate = function (callBack) {
            return self.on(self.EVENTS.ON_TAG_UPDATED_AFTER, callBack);
        };

        self.onUpdateFailed = function (callBack) {
            return self.on(self.EVENTS.ON_TAG_UPDATED_ERROR, callBack);
        };

        self.onBeforeDelete = function (callBack) {
            return self.on(self.EVENTS.ON_TAG_DELETED_BEFORE, callBack);
        };

        self.onAfterDelete = function (callBack) {
            return self.on(self.EVENTS.ON_TAG_DELETED_AFTER, callBack);
        };

        self.onDeleteFailed = function (callBack) {
            return self.on(self.EVENTS.ON_TAG_DELETED_ERROR, callBack);
        };

        self.onTagsFilterUpdated = function (callBack) {
            return self.on(self.EVENTS.ON_TAGS_FILTER_UPDATED, callBack);
        };

        return self;
    }
}());
